export const GET_CREATE_SEGMENT_DATA = "GET_CREATE_SEGMENT_DATA";
export const GET_EDIT_SEGMENT_DATA = "GET_EDIT_SEGMENT_DATA";
export const GET_SEGMENT_DETAILS = "GET_SEGMENT_DETAILS";
